import React, { Fragment, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  CircularProgress,
  FormControl,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";

import {
  inverterMappingArrayAction,
  projectDetailAction,
  scbSmbMappingArrayAction,
} from "../../actions/energyAction";
import {
  clear_errors,
  project_detail_reset,
} from "../../constants/dataConstants";

import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  IconButton,
  Typography,
  Divider,
  useMediaQuery,
  useTheme,
  Paper,
  Breadcrumbs,
} from "@mui/material";
import {

  ExpandLess as ExpandLessIcon,
  ChevronRight as ChevronRightIcon,

} from "@mui/icons-material";

import { useNavigate } from "react-router-dom";
import PageURL from "../../constants/PageURL";
import FetchProjectDetailLoader from "../../components/Loaders/FetchProjectDetailLoader";



const styles2 = {
  mainContent: {
    flexGrow: 1,
    p: 3,
    width: { md: `calc(100% - 250px)` },
    maxWidth: 1200,
    margin: "0 auto",
  },
  selectionCard: {
    p: 3,
    borderRadius: 2,
    background: "linear-gradient(to bottom right, #f5f7fa 0%, #ffffff 100%)",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    mb: 2,
    gap: 2,
  },
  headerIcon: {
    fontSize: "2.5rem",
    color: "primary.main",
  },
  titleContainer: {
    flex: 1,
  },
  projectTitle: {
    fontWeight: 700,
    letterSpacing: "-0.5px",
    lineHeight: 1.2,
  },
  projectSubtitle: {
    color: "text.secondary",
    display: "flex",
    alignItems: "center",
    gap: 1,
    "&::before": {
      content: '""',
      display: "inline-block",
      width: 4,
      height: 4,
      borderRadius: "50%",
      backgroundColor: "text.secondary",
    },
  },
};

// CSS styles
const styles = {
  listItem: {
    "& .MuiListItemButton-root": {
      paddingTop: "4px",
      paddingBottom: "4px",
    },
    "& .MuiListItemIcon-root": {
      minWidth: "32px", // Reduced from default 36px
    },
    "& .MuiListItemText-primary": {
      fontSize: "0.775rem", // Reduced from default 1rem
    },
    "& .MuiSvgIcon-root": {
      fontSize: "0.775rem", // Adjust icon size
    },
  },
  nestedItem: {
    "& .MuiListItemButton-root": {
      paddingLeft: "32px", // Indent nested items
      paddingTop: "2px",
      paddingBottom: "2px",
    },
    "& .MuiListItemText-primary": {
      fontSize: "0.775rem", // Slightly smaller for nested items
    },
  },
  listGap: {
    marginBottom: "4px", // Add gap between main list items
  },
  drawer: {
    width: 230,
    flexShrink: 0,
    "& .MuiDrawer-paper": {
      width: 230,
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
    },
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: "10px 16px",
    justifyContent: "space-between",
    background: "#203864",
    color: "white",
    border: "none",
    height: "70px",
  },
  logo: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
  },
  content: {
    flexGrow: 1,
    padding: "24px",
    transition: "margin 0.2s ease",
  },
  contentShift: {
    marginLeft: 250,
  },
  nestedItem: {
    paddingLeft: "20px",
  },
  nestedItemLevel2: {
    paddingLeft: "45px",
  },
  nestedItemLevel3: {
    paddingLeft: "55px",
  },
  nestedItemLevel4: {
    paddingLeft: "65px",
  },
  nestedItemLevel5: {
    paddingLeft: "75px",
  },
  menuButton: {
    position: "fixed",
    top: "10px",
    left: "20px",
    zIndex: 1200,
    backgroundColor: "white",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    "&:hover": {
      backgroundColor: "#203864",
    },
  },
  logoutContainer: {
    marginTop: "auto",
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    background: "#203864",
    color: "white",
  },
  mainContent: {
    padding: "20px",
  },
  selectionCard: {
    padding: "16px",
    marginBottom: "20px",
  },
  selectionItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: "8px",
  },
  selectionLabel: {
    fontWeight: "bold",
    marginRight: "8px",
    minWidth: "120px",
  },
  selectionValue: {
    color: "rgba(0, 0, 0, 0.7)",
  },
  ...styles2,
};



const ScbsmbDropdown = ({
  projectDetail,
  selectedValue,
  setSelectedValue,
  openMenus,
  toggleMenu,
  scbSmbMappingArray,
  scbSmbMappingLoader,
  databaseStr,
  scbsmbDetail,
  setscbsmbDetail,
  forecasting = false
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const serachParams = new URLSearchParams(location.search);


  const navigateIfNeeded = (normal, predictive, forecasting) => {
    const target = forecasting ? predictive : normal;

    if (location.pathname !== target) {
      navigate(`${target}?${serachParams.toString()}`);
    }
  };

  return (
    <>

      <List component="div" disablePadding>
        {scbSmbMappingLoader ? (
          <ListItem sx={{ justifyContent: "center" }}>
            <FetchProjectDetailLoader width="25px" />
          </ListItem>
        ) : !scbSmbMappingArray ? (
          <ListItem sx={styles.nestedItemLevel3}>
            {projectDetail?.plantDetail?.string || ""} Data Not Found
          </ListItem>
        ) : scbSmbMappingArray?.length === 0 ? (
          <ListItem sx={styles.nestedItemLevel3}>
            {projectDetail?.plantDetail?.string || ""} Data Not Available
          </ListItem>
        ) : (
          <>
            {scbSmbMappingArray.map((block) => (
              <React.Fragment key={block.name}>
                <ListItem disablePadding sx={styles.nestedItemLevel2}>
                  <ListItemButton
                    onClick={() => toggleMenu(`block-${block.name}`)}
                  >
                    <ListItemText
                      primaryTypographyProps={{
                        variant: "body2",
                        sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                      }}
                      primary={block.name}
                    />
                    {openMenus[`block-${block.name}`] ? (
                      <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                    ) : (
                      <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                    )}
                  </ListItemButton>
                </ListItem>

                <Collapse
                  in={openMenus[`block-${block.name}`]}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {block.subBlocks ? (
                      block.subBlocks.map((subBlock) => (
                        <React.Fragment
                          key={`${block.name}-${subBlock.name}`}
                        >
                          <ListItem
                            disablePadding
                            sx={styles.nestedItemLevel3}
                          >
                            <ListItemButton
                              onClick={() =>
                                toggleMenu(
                                  `subBlock-${block.name}-${subBlock.name}`
                                )
                              }
                            >
                              <ListItemText
                                primaryTypographyProps={{
                                  variant: "body2",
                                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                                }}
                                primary={subBlock.name}
                              />
                              {openMenus[
                                `subBlock-${block.name}-${subBlock.name}`
                              ] ? (
                                <ExpandLessIcon
                                  sx={{ fontSize: "0.775rem" }}
                                />
                              ) : (
                                <ChevronRightIcon
                                  sx={{ fontSize: "0.775rem" }}
                                />
                              )}
                            </ListItemButton>
                          </ListItem>

                          <Collapse
                            in={
                              openMenus[
                              `subBlock-${block.name}-${subBlock.name}`
                              ]
                            }
                            timeout="auto"
                            unmountOnExit
                          >
                            <List component="div" disablePadding>
                              {/* All Strings option for the sub-block */}
                              <ListItem
                                disablePadding
                                sx={styles.nestedItemLevel4}
                                selected={
                                  selectedValue.projectDetail ===
                                  `All ${projectDetail?.plantDetail?.string}` &&
                                  scbsmbDetail.block === block.name &&
                                  scbsmbDetail.sub_block === subBlock.name &&
                                  !scbsmbDetail.inverter &&
                                  !scbsmbDetail.stack
                                }
                              >
                                <ListItemButton
                                  onClick={() => {
                                    setSelectedValue({
                                      ...selectedValue,
                                      projectDetail: `All ${projectDetail?.plantDetail?.string}`,
                                    });

                                    setscbsmbDetail({
                                      block: block.name,
                                      sub_block: subBlock.name,
                                      inverter: null,
                                      inverterType: null,
                                      stack: null,
                                      scbsmb: null,
                                      scbsmbType: `${projectDetail?.plantDetail?.string ||
                                        ""
                                        }`,
                                    });

                                    // if (
                                    //   location.pathname !==
                                    //   PageURL.SCBSMBSTRING_DEVIATION
                                    // ) {
                                    //   navigate(
                                    //     `${forecasting ? PageURL.PREDICTIVE_SCBSMBSTRING_DEVIATION : PageURL.SCBSMBSTRING_DEVIATION
                                    //     }?${serachParams.toString()}`
                                    //   );
                                    // }

                                    navigateIfNeeded(
                                      PageURL.SCBSMBSTRING_LOSS,
                                      PageURL.PREDICTIVE_SCBSMBSTRING_LOSS,
                                      forecasting
                                    );
                                  }}
                                >
                                  <ListItemText
                                    primaryTypographyProps={{
                                      variant: "body2",
                                      sx: { fontSize: "0.775rem" },
                                    }}
                                    primary={`All ${projectDetail?.plantDetail?.string}`}
                                  />
                                </ListItemButton>
                              </ListItem>

                              {subBlock.inverters?.map((inverter) => (
                                <React.Fragment
                                  key={`${block.name}-${subBlock.name}-${inverter.name}`}
                                >
                                  <ListItem
                                    disablePadding
                                    sx={styles.nestedItemLevel4}
                                  >
                                    <ListItemButton
                                      onClick={() =>
                                        toggleMenu(
                                          `inverter-${block.name}-${subBlock.name}-${inverter.name}`
                                        )
                                      }
                                    >
                                      <ListItemText
                                        primaryTypographyProps={{
                                          variant: "body2",
                                          sx: {
                                            fontSize: "0.775rem",
                                          }, // Adjust text size (same as body2 default)
                                        }}
                                        primary={inverter.name}
                                      />
                                      {openMenus[
                                        `inverter-${block.name}-${subBlock.name}-${inverter.name}`
                                      ] ? (
                                        <ExpandLessIcon
                                          sx={{
                                            fontSize: "0.775rem",
                                          }}
                                        />
                                      ) : (
                                        <ChevronRightIcon
                                          sx={{
                                            fontSize: "0.775rem",
                                          }}
                                        />
                                      )}
                                    </ListItemButton>
                                  </ListItem>

                                  <Collapse
                                    in={
                                      openMenus[
                                      `inverter-${block.name}-${subBlock.name}-${inverter.name}`
                                      ]
                                    }
                                    timeout="auto"
                                    unmountOnExit
                                  >
                                    <List component="div" disablePadding>
                                      {/* All Strings option for the inverter */}
                                      {inverter.listScbsmb?.length > 1 &&
                                        projectDetail?.plantDetail?.string !==
                                        "SMB" && (
                                          <ListItem
                                            disablePadding
                                            sx={styles.nestedItemLevel5}
                                            selected={
                                              selectedValue.projectDetail ===
                                              `All ${projectDetail?.plantDetail
                                                ?.string || ""
                                              }` &&
                                              scbsmbDetail.block ===
                                              block.name &&
                                              scbsmbDetail.sub_block ===
                                              subBlock.name &&
                                              scbsmbDetail.inverter ===
                                              inverter.name
                                            }
                                          >
                                            <ListItemButton
                                              onClick={() => {
                                                setSelectedValue({
                                                  ...selectedValue,
                                                  projectDetail: `All ${projectDetail?.plantDetail
                                                    ?.string || ""
                                                    }`,
                                                });

                                                setscbsmbDetail({
                                                  block: block.name,
                                                  sub_block: subBlock.name,
                                                  inverter: inverter.name,
                                                  inverterType:
                                                    inverter.inverterType,
                                                  stack: null,
                                                  scbsmb: null,
                                                  scbsmbType: `${projectDetail?.plantDetail
                                                    ?.string || ""
                                                    }`,
                                                });

                                                // if (
                                                //   location.pathname !==
                                                //   PageURL.SCBSMBSTRING_DEVIATION
                                                // ) {
                                                //   navigate(
                                                //     `${forecasting ? PageURL.PREDICTIVE_SCBSMBSTRING_DEVIATION : PageURL.SCBSMBSTRING_DEVIATION
                                                //     }?${serachParams.toString()}`
                                                //   );
                                                // }

                                                navigateIfNeeded(
                                                  PageURL.SCBSMBSTRING_LOSS,
                                                  PageURL.PREDICTIVE_SCBSMBSTRING_LOSS,
                                                  forecasting
                                                );
                                              }}
                                            >
                                              <ListItemText
                                                primaryTypographyProps={{
                                                  variant: "body2",
                                                  sx: {
                                                    fontSize: "0.775rem",
                                                  },
                                                }}
                                                primary={`All ${projectDetail?.plantDetail
                                                  ?.string || ""
                                                  }`}
                                              />
                                            </ListItemButton>
                                          </ListItem>
                                        )}

                                      {/* HeatMap option */}
                                      <ListItem
                                        disablePadding
                                        sx={styles.nestedItemLevel5}
                                        selected={
                                          selectedValue.projectDetail ===
                                          "HeatMap" &&
                                          scbsmbDetail.block === block.name &&
                                          scbsmbDetail.sub_block ===
                                          subBlock.name &&
                                          scbsmbDetail.inverter ===
                                          inverter.name
                                        }
                                      >
                                        <ListItemButton
                                          onClick={() => {
                                            setSelectedValue({
                                              ...selectedValue,
                                              projectDetail: "HeatMap",
                                            });

                                            setscbsmbDetail({
                                              block: block.name,
                                              sub_block: subBlock.name,
                                              inverter: inverter.name,
                                              inverterType:
                                                inverter.inverterType,
                                              stack: null,
                                              scbsmb: null,
                                              heatmap: true,
                                              scbsmbType: `${projectDetail?.plantDetail
                                                ?.string || ""
                                                }`,
                                            });

                                            // if (
                                            //   location.pathname !==
                                            //   PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM
                                            // ) {
                                            //   navigate(
                                            //     `${forecasting ? PageURL.PREDICTIVE_INVERTER_HEATMAP_DIAGRAM : PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM
                                            //     }?${serachParams.toString()}`
                                            //   );
                                            // }

                                            navigateIfNeeded(
                                              PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM,
                                              PageURL.PREDICTIVE_INVERTER_HEATMAP_DIAGRAM,
                                              forecasting
                                            );
                                          }}
                                        >
                                          <ListItemText
                                            primaryTypographyProps={{
                                              variant: "body2",
                                              sx: {
                                                fontSize: "0.775rem",
                                              },
                                            }}
                                            primary="HeatMap"
                                          />
                                        </ListItemButton>
                                      </ListItem>

                                      {/* Handle both direct SCB/SMB list and stacks */}
                                      {inverter.listScbsmb ? (
                                        <>
                                          {/* Direct SCB/SMB list */}
                                          {inverter.listScbsmb.map(
                                            (scbSmb) => (
                                              <ListItem
                                                key={`${block.name}-${subBlock.name}-${inverter.name}-${scbSmb}`}
                                                disablePadding
                                                sx={styles.nestedItemLevel5}
                                                selected={
                                                  selectedValue.projectDetail ===
                                                  scbSmb &&
                                                  scbsmbDetail.block ===
                                                  block.name &&
                                                  scbsmbDetail.sub_block ===
                                                  subBlock.name &&
                                                  scbsmbDetail.inverter ===
                                                  inverter.name &&
                                                  scbsmbDetail.scbsmb ===
                                                  scbSmb
                                                }
                                              >
                                                <ListItemButton
                                                  onClick={() => {
                                                    setSelectedValue({
                                                      ...selectedValue,
                                                      projectDetail: scbSmb,
                                                    });

                                                    setscbsmbDetail({
                                                      block: block.name,
                                                      sub_block:
                                                        subBlock.name,
                                                      inverter: inverter.name,
                                                      inverterType:
                                                        inverter.inverterType,
                                                      stack: null,
                                                      scbsmb: scbSmb,
                                                      scbsmbType: `${projectDetail
                                                        ?.plantDetail
                                                        ?.string || ""
                                                        }`,
                                                    });

                                                    // if (
                                                    //   location.pathname !==
                                                    //   PageURL.SCBSMBSTRING_DEVIATION
                                                    // ) {
                                                    //   navigate(
                                                    //     `${forecasting ? PageURL.PREDICTIVE_SCBSMBSTRING_DEVIATION : PageURL.SCBSMBSTRING_DEVIATION
                                                    //     }?${serachParams.toString()}`
                                                    //   );
                                                    // }
                                                    navigateIfNeeded(
                                                      PageURL.SCBSMBSTRING_LOSS,
                                                      PageURL.PREDICTIVE_SCBSMBSTRING_LOSS,
                                                      forecasting
                                                    );

                                                  }}
                                                >
                                                  <ListItemText
                                                    primaryTypographyProps={{
                                                      variant: "body2",
                                                      sx: {
                                                        fontSize: "0.775rem",
                                                      },
                                                    }}
                                                    primary={scbSmb}
                                                  />
                                                </ListItemButton>
                                              </ListItem>
                                            )
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {/* Stacks handling */}
                                          {inverter.stacks?.map((stack) => (
                                            <React.Fragment
                                              key={`${block.name}-${subBlock.name}-${inverter.name}-${stack.name}`}
                                            >
                                              <ListItem
                                                disablePadding
                                                sx={styles.nestedItemLevel4}
                                              >
                                                <ListItemButton
                                                  onClick={() =>
                                                    toggleMenu(
                                                      `stack-${block.name}-${subBlock.name}-${inverter.name}-${stack.name}`
                                                    )
                                                  }
                                                >
                                                  <ListItemText
                                                    primaryTypographyProps={{
                                                      variant: "body2",
                                                      sx: {
                                                        fontSize: "0.775rem",
                                                      },
                                                    }}
                                                    primary={stack.name}
                                                  />
                                                  {openMenus[
                                                    `stack-${block.name}-${subBlock.name}-${inverter.name}-${stack.name}`
                                                  ] ? (
                                                    <ExpandLessIcon
                                                      sx={{
                                                        fontSize: "0.775rem",
                                                      }}
                                                    />
                                                  ) : (
                                                    <ChevronRightIcon
                                                      sx={{
                                                        fontSize: "0.775rem",
                                                      }}
                                                    />
                                                  )}
                                                </ListItemButton>
                                              </ListItem>

                                              <Collapse
                                                in={
                                                  openMenus[
                                                  `stack-${block.name}-${subBlock.name}-${inverter.name}-${stack.name}`
                                                  ]
                                                }
                                                timeout="auto"
                                                unmountOnExit
                                              >
                                                <List
                                                  component="div"
                                                  disablePadding
                                                >
                                                  {/* All Strings option for the stack */}
                                                  {stack.listScbsmb?.length >
                                                    1 &&
                                                    projectDetail?.plantDetail
                                                      ?.string !== "SMB" && (
                                                      <ListItem
                                                        disablePadding
                                                        sx={
                                                          styles.nestedItemLevel5
                                                        }
                                                        selected={
                                                          selectedValue.projectDetail ===
                                                          `All ${projectDetail
                                                            ?.plantDetail
                                                            ?.string || ""
                                                          }` &&
                                                          scbsmbDetail.block ===
                                                          block.name &&
                                                          scbsmbDetail.sub_block ===
                                                          subBlock.name &&
                                                          scbsmbDetail.inverter ===
                                                          inverter.name &&
                                                          scbsmbDetail.stack ===
                                                          stack.name
                                                        }
                                                      >
                                                        <ListItemButton
                                                          onClick={() => {
                                                            setSelectedValue({
                                                              ...selectedValue,
                                                              projectDetail: `All ${projectDetail
                                                                ?.plantDetail
                                                                ?.string ||
                                                                ""
                                                                }`,
                                                            });

                                                            setscbsmbDetail({
                                                              block:
                                                                block.name,
                                                              sub_block:
                                                                subBlock.name,
                                                              inverter:
                                                                inverter.name,
                                                              inverterType:
                                                                inverter.inverterType,
                                                              stack:
                                                                stack.name,
                                                              scbsmb: null,
                                                              scbsmbType: `${projectDetail
                                                                ?.plantDetail
                                                                ?.string ||
                                                                ""
                                                                }`,
                                                            });

                                                            // if (
                                                            //   location.pathname !==
                                                            //   PageURL.SCBSMBSTRING_DEVIATION
                                                            // ) {
                                                            //   navigate(
                                                            //     `${forecasting ? PageURL.PREDICTIVE_SCBSMBSTRING_DEVIATION : PageURL.SCBSMBSTRING_DEVIATION
                                                            //     }?${serachParams.toString()}`
                                                            //   );
                                                            // }

                                                            navigateIfNeeded(
                                                              PageURL.SCBSMBSTRING_LOSS,
                                                              PageURL.PREDICTIVE_SCBSMBSTRING_LOSS,
                                                              forecasting
                                                            );
                                                          }}
                                                        >
                                                          <ListItemText
                                                            primaryTypographyProps={{
                                                              variant:
                                                                "body2",
                                                              sx: {
                                                                fontSize:
                                                                  "0.775rem",
                                                              },
                                                            }}
                                                            primary={`All ${projectDetail
                                                              ?.plantDetail
                                                              ?.string || ""
                                                              }`}
                                                          />
                                                        </ListItemButton>
                                                      </ListItem>
                                                    )}

                                                  {/* HeatMap option for stack */}
                                                  <ListItem
                                                    disablePadding
                                                    sx={
                                                      styles.nestedItemLevel5
                                                    }
                                                    selected={
                                                      selectedValue.projectDetail ===
                                                      "HeatMap" &&
                                                      scbsmbDetail.block ===
                                                      block.name &&
                                                      scbsmbDetail.sub_block ===
                                                      subBlock.name &&
                                                      scbsmbDetail.inverter ===
                                                      inverter.name &&
                                                      scbsmbDetail.stack ===
                                                      stack.name
                                                    }
                                                  >
                                                    <ListItemButton
                                                      onClick={() => {
                                                        setSelectedValue({
                                                          ...selectedValue,
                                                          projectDetail:
                                                            "HeatMap",
                                                        });

                                                        setscbsmbDetail({
                                                          block: block.name,
                                                          sub_block:
                                                            subBlock.name,
                                                          inverter:
                                                            inverter.name,
                                                          inverterType:
                                                            inverter.inverterType,
                                                          stack: stack.name,
                                                          scbsmb: null,
                                                          heatmap: true,
                                                          scbsmbType: `${projectDetail
                                                            ?.plantDetail
                                                            ?.string || ""
                                                            }`,
                                                        });

                                                        // if (
                                                        //   location.pathname !==
                                                        //   PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM
                                                        // ) {
                                                        //   navigate(
                                                        //     `${forecasting ? PageURL.PREDICTIVE_INVERTER_HEATMAP_DIAGRAM : PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM
                                                        //     }?${serachParams.toString()}`
                                                        //   );
                                                        // }

                                                         navigateIfNeeded(
                                                      PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM,
                                                      PageURL.PREDICTIVE_INVERTER_HEATMAP_DIAGRAM,
                                                      forecasting
                                                    );
                                                      }}
                                                    >
                                                      <ListItemText
                                                        primaryTypographyProps={{
                                                          variant: "body2",
                                                          sx: {
                                                            fontSize:
                                                              "0.775rem",
                                                          },
                                                        }}
                                                        primary="HeatMap"
                                                      />
                                                    </ListItemButton>
                                                  </ListItem>

                                                  {/* SCB/SMB list for stack */}
                                                  {stack.listScbsmb?.map(
                                                    (scbSmb) => (
                                                      <ListItem
                                                        key={`${block.name}-${subBlock.name}-${inverter.name}-${stack.name}-${scbSmb}`}
                                                        disablePadding
                                                        sx={
                                                          styles.nestedItemLevel5
                                                        }
                                                        selected={
                                                          selectedValue.projectDetail ===
                                                          scbSmb &&
                                                          scbsmbDetail.block ===
                                                          block.name &&
                                                          scbsmbDetail.sub_block ===
                                                          subBlock.name &&
                                                          scbsmbDetail.inverter ===
                                                          inverter.name &&
                                                          scbsmbDetail.stack ===
                                                          stack.name &&
                                                          scbsmbDetail.scbsmb ===
                                                          scbSmb
                                                        }
                                                      >
                                                        <ListItemButton
                                                          onClick={() => {
                                                            setSelectedValue({
                                                              ...selectedValue,
                                                              projectDetail:
                                                                scbSmb,
                                                            });

                                                            setscbsmbDetail({
                                                              block:
                                                                block.name,
                                                              sub_block:
                                                                subBlock.name,
                                                              inverter:
                                                                inverter.name,
                                                              inverterType:
                                                                inverter.inverterType,
                                                              stack:
                                                                stack.name,
                                                              scbsmb: scbSmb,
                                                              scbsmbType: `${projectDetail
                                                                ?.plantDetail
                                                                ?.string ||
                                                                ""
                                                                }`,
                                                            });

                                                            // if (
                                                            //   location.pathname !==
                                                            //   PageURL.SCBSMBSTRING_DEVIATION
                                                            // ) {
                                                            //   navigate(
                                                            //     `${forecasting ? PageURL.PREDICTIVE_SCBSMBSTRING_DEVIATION : PageURL.SCBSMBSTRING_DEVIATION
                                                            //     }?${serachParams.toString()}`
                                                            //   );
                                                            // }

                                                              navigateIfNeeded(
                                                              PageURL.SCBSMBSTRING_LOSS,
                                                              PageURL.PREDICTIVE_SCBSMBSTRING_LOSS,
                                                              forecasting
                                                            );
                                                          }}
                                                        >
                                                          <ListItemText
                                                            primaryTypographyProps={{
                                                              variant:
                                                                "body2",
                                                              sx: {
                                                                fontSize:
                                                                  "0.775rem",
                                                              },
                                                            }}
                                                            primary={scbSmb}
                                                          />
                                                        </ListItemButton>
                                                      </ListItem>
                                                    )
                                                  )}
                                                </List>
                                              </Collapse>
                                            </React.Fragment>
                                          ))}
                                        </>
                                      )}
                                    </List>
                                  </Collapse>
                                </React.Fragment>
                              ))}
                            </List>
                          </Collapse>
                        </React.Fragment>
                      ))
                    ) : (
                      <>
                        {/* For blocks without subBlocks */}
                        {/* All Strings option for the block */}
                        {/* <ListItem

                                    disablePadding
                                    sx={styles.nestedItemLevel3}
                                    selected={
                                      selectedValue.projectDetail ===
                                        `All ${projectDetail?.plantDetail?.string}` &&
                                      scbsmbDetail.block === block.name &&
                                      !scbsmbDetail.sub_block &&
                                      !scbsmbDetail.inverter &&
                                      !scbsmbDetail.stack
                                    }
                                  >
                                    <ListItemButton
                                      onClick={() => {
                                        setSelectedValue({
                                          ...selectedValue,
                                          projectDetail: `All ${projectDetail?.plantDetail?.string}`,
                                        });

                                        setscbsmbDetail({
                                          block: block.name,
                                          sub_block: null,
                                          inverter: null,
                                          inverterType: null,
                                          stack: null,
                                          scbsmb: null,
                                          scbsmbType: `${
                                            projectDetail?.plantDetail
                                              ?.string || ""
                                          }`,
                                        });

                                        if (
                                          location.pathname !==
                                          PageURL.SCBSMB_LOSS
                                        ) {
                                          navigate(
                                            `${
                                              PageURL.SCBSMB_LOSS
                                            }?${serachParams.toString()}`
                                          );
                                        }
                                      }}
                                    >
                                      <ListItemText

                                        primaryTypographyProps={{
                                          variant: "body2",
                                        }}
                                        primary={`All ${projectDetail?.plantDetail?.string}`}
                                      />
                                    </ListItemButton>
                                  </ListItem> */}

                        {block.inverters?.map((inverter) => (
                          <React.Fragment
                            key={`${block.name}-${inverter.name}`}
                          >
                            <ListItem
                              disablePadding
                              sx={styles.nestedItemLevel3}
                            >
                              <ListItemButton
                                onClick={() =>
                                  toggleMenu(
                                    `inverter-${block.name}-${inverter.name}`
                                  )
                                }
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    variant: "body2",
                                    sx: { fontSize: "0.775rem" },
                                  }}
                                  primary={inverter.name}
                                />
                                {openMenus[
                                  `inverter-${block.name}-${inverter.name}`
                                ] ? (
                                  <ExpandLessIcon
                                    sx={{ fontSize: "0.775rem" }}
                                  />
                                ) : (
                                  <ChevronRightIcon
                                    sx={{ fontSize: "0.775rem" }}
                                  />
                                )}
                              </ListItemButton>
                            </ListItem>

                            <Collapse
                              in={
                                openMenus[
                                `inverter-${block.name}-${inverter.name}`
                                ]
                              }
                              timeout="auto"
                              unmountOnExit
                            >
                              <List component="div" disablePadding>
                                {/* All Strings option for the inverter */}
                                {inverter.listScbsmb?.length > 1 &&
                                  projectDetail?.plantDetail?.string !==
                                  "SMB" && (
                                    <ListItem
                                      disablePadding
                                      sx={styles.nestedItemLevel4}
                                      selected={
                                        selectedValue.projectDetail ===
                                        `All ${projectDetail?.plantDetail
                                          ?.string || ""
                                        }` &&
                                        scbsmbDetail.block === block.name &&
                                        scbsmbDetail.inverter ===
                                        inverter.name
                                      }
                                    >
                                      <ListItemButton
                                        onClick={() => {
                                          setSelectedValue({
                                            ...selectedValue,
                                            projectDetail: `All ${projectDetail?.plantDetail
                                              ?.string || ""
                                              }`,
                                          });

                                          setscbsmbDetail({
                                            block: block.name,
                                            sub_block: null,
                                            inverter: inverter.name,
                                            inverterType:
                                              inverter.inverterType,
                                            stack: null,
                                            scbsmb: null,
                                            scbsmbType: `${projectDetail?.plantDetail
                                              ?.string || ""
                                              }`,
                                          });

                                          // if (
                                          //   location.pathname !==
                                          //   PageURL.SCBSMBSTRING_DEVIATION
                                          // ) {
                                          //   navigate(
                                          //     `${forecasting ? PageURL.PREDICTIVE_SCBSMBSTRING_DEVIATION : PageURL.SCBSMBSTRING_DEVIATION
                                          //     }?${serachParams.toString()}`
                                          //   );
                                          // }

                                          navigateIfNeeded(
                                                              PageURL.SCBSMBSTRING_LOSS,
                                                              PageURL.PREDICTIVE_SCBSMBSTRING_LOSS,
                                                              forecasting
                                                            );
                                        }}
                                      >
                                        <ListItemText
                                          primaryTypographyProps={{
                                            variant: "body2",
                                            sx: {
                                              fontSize: "0.775rem",
                                            },
                                          }}
                                          primary={`All ${projectDetail?.plantDetail
                                            ?.string || ""
                                            }`}
                                        />
                                      </ListItemButton>
                                    </ListItem>
                                  )}

                                {/* Handle both direct SCB/SMB list and stacks */}
                                {inverter.listScbsmb ? (
                                  <>
                                    {/* HeatMap option */}
                                    <ListItem
                                      disablePadding
                                      sx={styles.nestedItemLevel4}
                                      selected={
                                        selectedValue.projectDetail ===
                                        "HeatMap" &&
                                        scbsmbDetail.block === block.name &&
                                        scbsmbDetail.inverter ===
                                        inverter.name
                                      }
                                    >
                                      <ListItemButton
                                        onClick={() => {
                                          setSelectedValue({
                                            ...selectedValue,
                                            projectDetail: "HeatMap",
                                          });

                                          setscbsmbDetail({
                                            block: block.name,
                                            sub_block: null,
                                            inverter: inverter.name,
                                            inverterType:
                                              inverter.inverterType,
                                            stack: null,
                                            scbsmb: null,
                                            heatmap: true,
                                            scbsmbType: `${projectDetail?.plantDetail
                                              ?.string || ""
                                              }`,
                                          });

                                          // if (
                                          //   location.pathname !==
                                          //   PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM
                                          // ) {
                                          //   navigate(
                                          //     `${forecasting ? PageURL.PREDICTIVE_INVERTER_HEATMAP_DIAGRAM : PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM
                                          //     }?${serachParams.toString()}`
                                          //   );
                                          // }
                                            navigateIfNeeded(
                                              PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM,
                                              PageURL.PREDICTIVE_INVERTER_HEATMAP_DIAGRAM,
                                              forecasting
                                             );
                                        }}
                                      >
                                        <ListItemText
                                          primaryTypographyProps={{
                                            variant: "body2",
                                            sx: {
                                              fontSize: "0.775rem",
                                            },
                                          }}
                                          primary="HeatMap"
                                        />
                                      </ListItemButton>
                                    </ListItem>
                                    {/* Direct SCB/SMB list */}
                                    {inverter.listScbsmb.map((scbSmb) => (
                                      <ListItem
                                        key={`${block.name}-${inverter.name}-${scbSmb}`}
                                        disablePadding
                                        sx={styles.nestedItemLevel4}
                                        selected={
                                          selectedValue.projectDetail ===
                                          scbSmb &&
                                          scbsmbDetail.block === block.name &&
                                          scbsmbDetail.inverter ===
                                          inverter.name &&
                                          scbsmbDetail.scbsmb === scbSmb
                                        }
                                      >
                                        <ListItemButton
                                          onClick={() => {
                                            setSelectedValue({
                                              ...selectedValue,
                                              projectDetail: scbSmb,
                                            });

                                            setscbsmbDetail({
                                              block: block.name,
                                              sub_block: null,
                                              inverter: inverter.name,
                                              inverterType:
                                                inverter.inverterType,
                                              stack: null,
                                              scbsmb: scbSmb,
                                              scbsmbType: `${projectDetail?.plantDetail
                                                ?.string || ""
                                                }`,
                                            });

                                            // if (
                                            //   location.pathname !==
                                            //   PageURL.SCBSMBSTRING_DEVIATION
                                            // ) {
                                            //   navigate(
                                            //     `${forecasting ? PageURL.PREDICTIVE_SCBSMBSTRING_DEVIATION : PageURL.SCBSMBSTRING_DEVIATION
                                            //     }?${serachParams.toString()}`
                                            //   );
                                            // }
                                            navigateIfNeeded(
                                                              PageURL.SCBSMBSTRING_LOSS,
                                                              PageURL.PREDICTIVE_SCBSMBSTRING_LOSS,
                                                              forecasting
                                                            );
                                          }}
                                        >
                                          <ListItemText
                                            primaryTypographyProps={{
                                              variant: "body2",
                                              sx: {
                                                fontSize: "0.775rem",
                                              },
                                            }}
                                            primary={scbSmb}
                                          />
                                        </ListItemButton>
                                      </ListItem>
                                    ))}
                                  </>
                                ) : (
                                  <>
                                    {/* Stacks handling */}
                                    {inverter.stacks?.map((stack) => (
                                      <React.Fragment
                                        key={`${block.name}-${inverter.name}-${stack.name}`}
                                      >
                                        <ListItem
                                          disablePadding
                                          sx={styles.nestedItemLevel4}
                                        >
                                          <ListItemButton
                                            onClick={() =>
                                              toggleMenu(
                                                `stack-${block.name}-${inverter.name}-${stack.name}`
                                              )
                                            }
                                          >
                                            <ListItemText
                                              primaryTypographyProps={{
                                                variant: "body2",
                                                sx: {
                                                  fontSize: "0.775rem",
                                                },
                                              }}
                                              primary={stack.name}
                                            />
                                            {openMenus[
                                              `stack-${block.name}-${inverter.name}-${stack.name}`
                                            ] ? (
                                              <ExpandLessIcon
                                                sx={{
                                                  fontSize: "0.775rem",
                                                }}
                                              />
                                            ) : (
                                              <ChevronRightIcon
                                                sx={{
                                                  fontSize: "0.775rem",
                                                }}
                                              />
                                            )}
                                          </ListItemButton>
                                        </ListItem>

                                        <Collapse
                                          in={
                                            openMenus[
                                            `stack-${block.name}-${inverter.name}-${stack.name}`
                                            ]
                                          }
                                          timeout="auto"
                                          unmountOnExit
                                        >
                                          <List
                                            component="div"
                                            disablePadding
                                          >
                                            {/* All Strings option for the stack */}
                                            {stack.listScbsmb?.length > 1 &&
                                              projectDetail?.plantDetail
                                                ?.string !== "SMB" && (
                                                <ListItem
                                                  disablePadding
                                                  sx={styles.nestedItemLevel5}
                                                  selected={
                                                    selectedValue.projectDetail ===
                                                    `All ${projectDetail
                                                      ?.plantDetail
                                                      ?.string || ""
                                                    }` &&
                                                    scbsmbDetail.block ===
                                                    block.name &&
                                                    scbsmbDetail.inverter ===
                                                    inverter.name &&
                                                    scbsmbDetail.stack ===
                                                    stack.name
                                                  }
                                                >
                                                  <ListItemButton
                                                    onClick={() => {
                                                      setSelectedValue({
                                                        ...selectedValue,
                                                        projectDetail: `All ${projectDetail
                                                          ?.plantDetail
                                                          ?.string || ""
                                                          }`,
                                                      });

                                                      setscbsmbDetail({
                                                        block: block.name,
                                                        sub_block: null,
                                                        inverter:
                                                          inverter.name,
                                                        inverterType:
                                                          inverter.inverterType,
                                                        stack: stack.name,
                                                        scbsmb: null,
                                                        scbsmbType: `${projectDetail
                                                          ?.plantDetail
                                                          ?.string || ""
                                                          }`,
                                                      });

                                                      // if (
                                                      //   location.pathname !==
                                                      //   PageURL.SCBSMBSTRING_DEVIATION
                                                      // ) {
                                                      //   navigate(
                                                      //     `${forecasting ? PageURL.PREDICTIVE_SCBSMBSTRING_DEVIATION : PageURL.SCBSMBSTRING_DEVIATION
                                                      //     }?${serachParams.toString()}`
                                                      //   );
                                                      // }

                                                      navigateIfNeeded(
                                                              PageURL.SCBSMBSTRING_LOSS,
                                                              PageURL.PREDICTIVE_SCBSMBSTRING_LOSS,
                                                              forecasting
                                                            );
                                                    }}
                                                  >
                                                    <ListItemText
                                                      primaryTypographyProps={{
                                                        variant: "body2",
                                                        sx: {
                                                          fontSize:
                                                            "0.775rem",
                                                        },
                                                      }}
                                                      primary={`All ${projectDetail
                                                        ?.plantDetail
                                                        ?.string || ""
                                                        }`}
                                                    />
                                                  </ListItemButton>
                                                </ListItem>
                                              )}

                                            {/* HeatMap option for stack */}
                                            <ListItem
                                              disablePadding
                                              sx={styles.nestedItemLevel5}
                                              selected={
                                                selectedValue.projectDetail ===
                                                "HeatMap" &&
                                                scbsmbDetail.block ===
                                                block.name &&
                                                scbsmbDetail.inverter ===
                                                inverter.name &&
                                                scbsmbDetail.stack ===
                                                stack.name
                                              }
                                            >
                                              <ListItemButton
                                                onClick={() => {
                                                  setSelectedValue({
                                                    ...selectedValue,
                                                    projectDetail: "HeatMap",
                                                  });

                                                  setscbsmbDetail({
                                                    block: block.name,
                                                    sub_block: null,
                                                    inverter: inverter.name,
                                                    inverterType:
                                                      inverter.inverterType,
                                                    stack: stack.name,
                                                    scbsmb: null,
                                                    heatmap: true,
                                                    scbsmbType: `${projectDetail
                                                      ?.plantDetail
                                                      ?.string || ""
                                                      }`,
                                                  });

                                                  // if (
                                                  //   location.pathname !==
                                                  //   PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM
                                                  // ) {
                                                  //   navigate(
                                                  //     `${forecasting ? PageURL.PREDICTIVE_INVERTER_HEATMAP_DIAGRAM : PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM
                                                  //     }?${serachParams.toString()}`
                                                  //   );
                                                  // }

                                                    navigateIfNeeded(
                                              PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM,
                                              PageURL.PREDICTIVE_INVERTER_HEATMAP_DIAGRAM,
                                              forecasting
                                             );
                                                }}
                                              >
                                                <ListItemText
                                                  primaryTypographyProps={{
                                                    variant: "body2",
                                                    sx: {
                                                      fontSize: "0.775rem",
                                                    }, // Adjust text size (same as body2 default)
                                                  }}
                                                  primary="HeatMap"
                                                />
                                              </ListItemButton>
                                            </ListItem>

                                            {/* SCB/SMB list for stack */}
                                            {stack.listScbsmb?.map(
                                              (scbSmb) => (
                                                <ListItem
                                                  key={`${block.name}-${inverter.name}-${stack.name}-${scbSmb}`}
                                                  disablePadding
                                                  sx={styles.nestedItemLevel5}
                                                  selected={
                                                    selectedValue.projectDetail ===
                                                    scbSmb &&
                                                    scbsmbDetail.block ===
                                                    block.name &&
                                                    scbsmbDetail.inverter ===
                                                    inverter.name &&
                                                    scbsmbDetail.stack ===
                                                    stack.name &&
                                                    scbsmbDetail.scbsmb ===
                                                    scbSmb
                                                  }
                                                >
                                                  <ListItemButton
                                                    onClick={() => {
                                                      setSelectedValue({
                                                        ...selectedValue,
                                                        projectDetail: scbSmb,
                                                      });

                                                      setscbsmbDetail({
                                                        block: block.name,
                                                        sub_block: null,
                                                        inverter:
                                                          inverter.name,
                                                        inverterType:
                                                          inverter.inverterType,
                                                        stack: stack.name,
                                                        scbsmb: scbSmb,
                                                        scbsmbType: `${projectDetail
                                                          ?.plantDetail
                                                          ?.string || ""
                                                          }`,
                                                      });

                                                      // if (
                                                      //   location.pathname !==
                                                      //   PageURL.SCBSMBSTRING_DEVIATION
                                                      // ) {
                                                      //   navigate(
                                                      //     `${forecasting ? PageURL.PREDICTIVE_SCBSMBSTRING_DEVIATION : PageURL.SCBSMBSTRING_DEVIATION
                                                      //     }?${serachParams.toString()}`
                                                      //   );
                                                      // }
                                                      navigateIfNeeded(
                                                              PageURL.SCBSMBSTRING_LOSS,
                                                              PageURL.PREDICTIVE_SCBSMBSTRING_LOSS,
                                                              forecasting
                                                            );
                                                    }}
                                                  >
                                                    <ListItemText
                                                      primaryTypographyProps={{
                                                        variant: "body2",
                                                        sx: {
                                                          fontSize:
                                                            "0.775rem",
                                                        },
                                                      }}
                                                      primary={scbSmb}
                                                    />
                                                  </ListItemButton>
                                                </ListItem>
                                              )
                                            )}
                                          </List>
                                        </Collapse>
                                      </React.Fragment>
                                    ))}
                                  </>
                                )}
                              </List>
                            </Collapse>
                          </React.Fragment>
                        ))}
                      </>
                    )}
                  </List>
                </Collapse>
              </React.Fragment>
            ))}
          </>
        )}
      </List>
    </>
  );
};

export default ScbsmbDropdown;
